import { Route, Router } from "flemo";

import { NativeSplashController } from "@/components/NativeSplashController";
import { useNotificationSettingsInitializer } from "@/hooks/useNotificationSettingsInitializer";
import { usePageViewTracker } from "@/hooks/usePageViewTracker";
import { usePurchaseListener } from "@/hooks/usePurchaseListener";
import { fadeTransition } from "@/lib/transitions";

import { FlashcardPage } from "./flashcard";
import { FlashcardsPage } from "./flashcards";
import { LoginPage } from "./LoginPage";
import { MainPage } from "./main";
import { OnboardingPage } from "./onboarding";
import { PrivacyPage } from "./PrivacyPage";
import { ProfilePage } from "./profile";
import { RedirectToHome } from "./RedirectToHome";
import { SettingsPage } from "./settings";
import { SmartReviewPage } from "./smart-review";
import { SupportPage } from "./SupportPage";
import { TermsPage } from "./terms";
import { TestPage } from "./test";
import { TestListPage } from "./tests";

export function AppRouter() {
  useNotificationSettingsInitializer();
  usePageViewTracker();
  usePurchaseListener();

  return (
    <>
      <NativeSplashController />
      <Router transitions={[fadeTransition]}>
        <Route path="/" element={<MainPage />} />
        <Route path="/flashcards" element={<FlashcardsPage />} />
        <Route path="/flashcards/:id" element={<FlashcardPage />} />
        <Route path="/tests" element={<TestListPage />} />
        <Route path="/tests/:id" element={<TestPage />} />
        <Route path="/smart-review" element={<SmartReviewPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/profile" element={<ProfilePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/*path" element={<RedirectToHome />} />
      </Router>
    </>
  );
}
